/**
 * Сигнал «показати попап подарунка за промокодом» (owner 2026-08-28).
 *
 * Той самий патерн, що `retentionOffer.ts`: модалка змонтована глобально в
 * корені App, а відкривається звідки завгодно — з deeplink `?gift=<slug>`.
 * Module-level, без провайдера.
 */

let _slug: string | null = null;
const subs = new Set<(s: string | null) => void>();

export function openPromoGift(slug: string): void {
  _slug = slug;
  subs.forEach((f) => f(_slug));
}

export function closePromoGift(): void {
  _slug = null;
  subs.forEach((f) => f(_slug));
}

export function getPromoGift(): string | null {
  return _slug;
}

export function subscribePromoGift(fn: (s: string | null) => void): () => void {
  subs.add(fn);
  return () => {
    subs.delete(fn);
  };
}
